import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=2232be5d&scoped=true&"
import script from "./FileManager.vue?vue&type=script&lang=js&"
export * from "./FileManager.vue?vue&type=script&lang=js&"
import style0 from "./FileManager.vue?vue&type=style&index=0&id=2232be5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232be5d",
  null
  
)

export default component.exports